import { CreateKeyValueRequest } from "../base/createKeyValueRequest.model";

export class CreateTipoBonificacionRequest extends CreateKeyValueRequest {
  public tieneComision: boolean = false
}
